import { render, staticRenderFns } from "./LandingCatalogue.vue?vue&type=template&id=486e51e3&scoped=true&"
import script from "./LandingCatalogue.vue?vue&type=script&lang=ts&"
export * from "./LandingCatalogue.vue?vue&type=script&lang=ts&"
import style0 from "./LandingCatalogue.vue?vue&type=style&index=0&id=486e51e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486e51e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout,VSpacer})
